import { render, staticRenderFns } from "./r-currencies-holder-page.vue?vue&type=template&id=c5c06fc0"
import script from "./r-currencies-holder-page.vue?vue&type=script&lang=js"
export * from "./r-currencies-holder-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5c06fc0')) {
      api.createRecord('c5c06fc0', component.options)
    } else {
      api.reload('c5c06fc0', component.options)
    }
    module.hot.accept("./r-currencies-holder-page.vue?vue&type=template&id=c5c06fc0", function () {
      api.rerender('c5c06fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currencies-holder-page.vue"
export default component.exports